import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React, { useLayoutEffect } from 'react';
import _ from 'lodash';
import i18n from 'i18next';
import cx from 'classnames';
import moment from 'moment';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
am4core.useTheme(am4themes_animated);
var t = i18n.getFixedT(null, 'traffic-live');
var SevenChartListModel = /*#__PURE__*/React.memo(function (props) {
  var previousData = props.previousData,
      dateAry = props.dateAry,
      visitLog = props.visitLog;
  useLayoutEffect(function () {
    var chart = am4core.create('predictionChart-seven', am4charts.XYChart); //  am4core.addLicense

    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in

    chart.cursor = new am4charts.XYCursor(); // Create axes

    var categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'time';
    categoryAxis.dataItems.template.text = '{time}';
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 40;
    categoryAxis.cursorTooltipEnabled = false; // y-axes

    var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
    valueAxis.renderer.minGridDistance = 30;
    valueAxis.min = 0;
    valueAxis.title.text = '分鐘';
    valueAxis.cursorTooltipEnabled = false; // Set up series - lineSeries
    // series pickup & return

    var series_pickUp = chart.series.push(new am4charts.LineSeries());
    series_pickUp.dataFields.categoryX = 'time'; // series_pickUp.dataFields.valueY = 'pickUpEstTrailerLineQty'

    series_pickUp.dataFields.valueY = 'avgVisitDurationMins';
    series_pickUp.strokeWidth = 2;
    series_pickUp.name = t('lbl-pickUp-return');
    series_pickUp.adapter.add('tooltipText', function (text, target) {
      var time = target.tooltipDataItem.dataContext.time;
      var avgVisitDurationMins = previousData[target.tooltipDataItem.dataContext.key].avgVisitDurationMins; // let pickUpWorkTime = `${t('lbl-pickUp-minutes', {minutes: pickUpItem.avgVisitDurationMins})}`
      // let retrunWorkTime = `${t('lbl-return-minutes', {minutes: returnItem.avgVisitDurationMins})}`
      // const valueY = `${pickUpWorkTime}，${retrunWorkTime}`

      var pickupReturnText = "".concat(t('lbl-pickUp-return-minutes', {
        minutes: avgVisitDurationMins
      }));
      target.tooltip.getFillFromObject = false;
      target.tooltip.background.fill = am4core.color("#000");
      return "".concat(time, "\n").concat(pickupReturnText);
    }); // Add simple bullet max

    var bullet_pickup_max = series_pickUp.bullets.push(new am4charts.Bullet());
    bullet_pickup_max.disabled = true;
    bullet_pickup_max.propertyFields.disabled = "isMax";
    var circle_pickup_max = bullet_pickup_max.createChild(am4core.Circle);
    circle_pickup_max.width = 10;
    circle_pickup_max.height = 10;
    circle_pickup_max.stroke = am4core.color('#ff3c3c');
    circle_pickup_max.fill = am4core.color('#ff3c3c');
    circle_pickup_max.horizontalCenter = "middle";
    circle_pickup_max.verticalCenter = "middle"; // Add simple bullet min

    var bullet_pickup_min = series_pickUp.bullets.push(new am4charts.Bullet());
    bullet_pickup_min.disabled = true;
    bullet_pickup_min.propertyFields.disabled = "isMin";
    var circle_pickup_min = bullet_pickup_min.createChild(am4core.Circle);
    circle_pickup_min.width = 10;
    circle_pickup_min.height = 10;
    circle_pickup_min.stroke = am4core.color('#55c836');
    circle_pickup_min.fill = am4core.color('#55c836');
    circle_pickup_min.horizontalCenter = "middle";
    circle_pickup_min.verticalCenter = "middle"; // // series return
    // let series_return = chart.series.push(new am4charts.LineSeries())
    // series_return.dataFields.categoryX = 'time'
    // series_return.dataFields.valueY = 'returnEstTrailerLineQty'
    // series_return.strokeWidth = 2
    // series_return.name = t('lbl-return')
    //     // Add simple bullet max
    // let bullet_return_max = series_return.bullets.push(new am4charts.Bullet())
    // bullet_return_max.disabled = true
    // bullet_return_max.propertyFields.disabled = "isMaxReturn"
    // let circle_return_max = bullet_return_max.createChild(am4core.Circle)
    // circle_return_max.width = 10
    // circle_return_max.height = 10
    // circle_return_max.stroke= am4core.color('#ff3c3c')
    // circle_return_max.fill = am4core.color('#ff3c3c')
    // circle_return_max.horizontalCenter = "middle"
    // circle_return_max.verticalCenter = "middle"
    //     // Add simple bullet min
    // let bullet_return_min = series_return.bullets.push(new am4charts.Bullet())
    // bullet_return_min.disabled = true
    // bullet_return_min.propertyFields.disabled = "isMinReturn"
    // let circle_return_min = bullet_return_min.createChild(am4core.Circle)
    // circle_return_min.width = 10
    // circle_return_min.height = 10
    // circle_return_min.stroke= am4core.color('#55c836')
    // circle_return_min.fill = am4core.color('#55c836')
    // circle_return_min.horizontalCenter = "middle"
    // circle_return_min.verticalCenter = "middle"
    // Add a legend

    chart.legend = new am4charts.Legend();
    chart.legend.position = 'right';
    chart.legend.maxWidth = '100';
    chart.legend.fontSize = '12'; // add range

    var range = categoryAxis.axisRanges.create();
    range.category = '00:00';
    range.text = '';
    range.grid.stroke = am4core.color('#ff3c3c');
    range.grid.strokeOpacity = 5;
    chart.data = _.map(previousData, function (el, key) {
      var obj = {};
      obj.avgVisitDurationMins = el.avgVisitDurationMins;
      obj.isMax = !_.isEmpty(el) && el.isMax ? false : true;
      obj.isMin = !_.isEmpty(el) && el.isMin ? false : true; // obj.pickUpEstTrailerLineQty = _.isEmpty(el.pickUpItem) || parseInt(el.pickUpItem.avgVisitDurationMins) === -1 ? 0 : parseInt(el.pickUpItem.avgVisitDurationMins)
      // obj.isMaxPickUp = !_.isEmpty(el.pickUpItem) && el.pickUpItem.isMax ? false : true
      // obj.isMinPickUp = !_.isEmpty(el.pickUpItem) && el.pickUpItem.isMin ? false : true
      // obj.returnEstTrailerLineQty = _.isEmpty(el.returnItem) || parseInt(el.returnItem.avgVisitDurationMins) === -1 ? 0 : parseInt(el.returnItem.avgVisitDurationMins)
      // obj.isMaxReturn = !_.isEmpty(el.returnItem) && el.returnItem.isMax ? false : true 
      // obj.isMinReturn = !_.isEmpty(el.returnItem) && el.returnItem.isMin ? false : true

      return _objectSpread({
        key: key,
        time: moment(parseInt(key)).format('HH:mm')
      }, obj);
    }); // hide amcharts4 logo

    var eles = document.querySelectorAll('[aria-labelledby$=-title]');
    eles.forEach(function (ele) {
      ele.style.visibility = 'hidden';
    });
    return function () {
      chart.dispose();
    };
  }, [JSON.stringify(previousData)]);

  var renderList = function renderList() {
    return _.map(visitLog, function (el, key) {
      return /*#__PURE__*/React.createElement("div", {
        className: "item",
        key: key
      }, /*#__PURE__*/React.createElement("p", null, el.deliverType === 'PickUp' ? t('lbl-pickUp') : t('lbl-return')), /*#__PURE__*/React.createElement("p", null, el.entryTime && moment(el.entryTime).format('MM/DD HH:mm')), /*#__PURE__*/React.createElement("p", null, el.exitTime && moment(el.exitTime).format('MM/DD HH:mm')), /*#__PURE__*/React.createElement("p", null, el.workingTimeInMins >= 0 ? t('lbl-minutes', {
        minutes: el.workingTimeInMins
      }) : ''));
    });
  };

  var renderDate = function renderDate() {
    return dateAry.map(function (el, index) {
      var daysTextAry = ['日', '一', '二', '三', '四', '五', '六'];
      var day = daysTextAry[new Date(el).getDay()];
      return /*#__PURE__*/React.createElement("span", {
        key: "chart-date-".concat(index),
        className: "date-".concat(index)
      }, "".concat(el, "(").concat(day, ")"));
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "title"
  }, t('lbl-terminal-past-twenty-four-title')), /*#__PURE__*/React.createElement("div", {
    className: cx('chart-date', 'terminal', {
      'two': dateAry.length == 2
    })
  }, renderDate()), /*#__PURE__*/React.createElement("div", {
    id: "predictionChart-seven"
  }), /*#__PURE__*/React.createElement("div", {
    className: "prediction-list seven"
  }, /*#__PURE__*/React.createElement("div", {
    className: "item"
  }, /*#__PURE__*/React.createElement("p", null, t('lbl-deliverType')), /*#__PURE__*/React.createElement("p", null, t('lbl-entryTime')), /*#__PURE__*/React.createElement("p", null, t('lbl-exitTime')), /*#__PURE__*/React.createElement("p", null, t('lbl-workingTime'))), /*#__PURE__*/React.createElement("div", {
    className: "list-content"
  }, renderList())));
});
export default SevenChartListModel;